import { Link, useLocation } from "react-router-dom";
import "./Footer.css";
import { useLanguage } from "../contexts/LanguageContext"

function Footer(props) {
    const { t } = useLanguage();
    const location = useLocation();

    // Smooth scroll to top function
    const smoothScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Handle footer link clicks
    const handleFooterLinkClick = (e, linkTo) => {
        // If clicking on the same page, prevent default and scroll to top
        if (location.pathname === linkTo) {
            e.preventDefault();
            smoothScrollToTop();
        }
        // If going to a different page, scroll will happen automatically via ScrollToTop component
    };

    return (
        <footer className="site-footer">
            <div className="footer-content">
                <div className="footer-left">
                    <h3 className="footer-title">{t.footer.woodcarverFullName}</h3>
                    <p className="footer-subtitle">{t.footer.description}</p>
                </div>

                <div className="footer-center">
                    <Link 
                        to="/gallery" 
                        className="footer-link"
                        onClick={(e) => handleFooterLinkClick(e, "/gallery")}
                    >
                        {t.footer.gallery}
                    </Link>
                    <Link 
                        to="/about" 
                        className="footer-link"
                        onClick={(e) => handleFooterLinkClick(e, "/about")}
                    >
                        {t.footer.about}
                    </Link>
                    <Link 
                        to="/contact" 
                        className="footer-link"
                        onClick={(e) => handleFooterLinkClick(e, "/contact")}
                    >
                        {t.footer.contact}
                    </Link>
                </div>

                <div className="footer-right">
                    <a 
                        href="https://www.facebook.com" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="footer-social"
                    >
                        Facebook
                    </a>
                    <a 
                        href="https://www.instagram.com" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="footer-social"
                    >
                        Instagram
                    </a>
                </div>
            </div>

            <div className="footer-bottom">
                © {new Date().getFullYear()} Panagiotis Bekos — All rights reserved
            </div>
        </footer>
    );
}

export default Footer;